import Booking from '../views/booking/bookingListing';
import ClientAwb from '../views/booking/generateClientAwb';
import pendingPushToManifestBookingList from '../views/pushpendingshipments';
import Uploadloglist from '../views/booking/Uploadloglist';
import FlipkartSoftDataUpload from '../views/booking/flipkartSoftDataUpload';
import PrintMpsStickers from '../views/printMpsStickers';
import PrintAWB from '../views/printAWB';
import abfrllogs from '../views/booking/abfrlLogs';
import cargosellerdetails from '../views/booking/cargosellerdetails/cargosellerdetailsListing';
import FCAddressdetails from '../views/booking/FCAddressdetails/FCAddressListing';
import pincodeallocationdetails from '../views/booking/pincodeallocationdetails';
import bookingdashboard from '../views/booking/bookingdashboard';
import ChangeBookingDetails from '../views/updateBookingDetails';
import AirWalletRateCalculator from'../views/booking/airwalletratecalculator';
import B2BMarketPlaceSellerDetailsListing from '../views/B2BMarketPlace/SellerDetails/SellerDetailsListing';
import B2BMarketPlaceDeliveryDetailsListing from '../views/B2BMarketPlace/DeliveryDetails/DeliveryDetailsListing';

export default [
	{
		path: '/Booking',
		name: 'booking',
		component: Booking,
		title: 'booking',
		meta: {
      requiresAuth: true
  }
},
	{
		path: '/ClientAwb',
		name: 'ClientAwb',
		component: ClientAwb,
		title: 'ClientAwb',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/pendingPushToManifestBookingList',
		name: 'pendingPushToManifestBookingList',
		component: pendingPushToManifestBookingList,
		title: 'pendingPushToManifestBookingList',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/Uploadloglist',
		name: 'Uploadloglist',
		component:Uploadloglist,
		title: 'Uploadloglist',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/flipkartSoftDataUpload',
		name: 'flipkartSoftDataUpload',
		component:FlipkartSoftDataUpload,
		title: 'flipkartSoftDataUpload',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/printMpsStickers',
		name: 'Cargo Print Sticker',
		component:PrintMpsStickers,
		title: 'Cargo Print Sticker',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/abfrllogs',
		name: 'ABFRL Logs',
		component:abfrllogs,
		title: 'ABFRL Logs',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/printAWB',
		name: 'Print AWB',
		component:PrintAWB,
		title: 'Print AWB',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/cargosellerdetails',
		name: 'cargosellerdetails',
		component:cargosellerdetails,
		title: 'cargosellerdetails',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/FCAddressdetails',
		name: 'FCAddressdetails',
		component:FCAddressdetails,
		title: 'FCAddressdetails',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/pincodeallocationdetails',
		name: 'pincodeallocationdetails',
		component:pincodeallocationdetails,
		title: 'pincodeallocationdetails',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/bookingdashboard',
		name: 'bookingdashboard',
		component:bookingdashboard,
		title: 'bookingdashboard',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/changebookingdetails',
		name: 'changebookingdetails',
		component: ChangeBookingDetails,
		title: 'changebookingdetails',
		meta: {
		  requiresAuth: true
		}
	},
	{
		path: '/aircargoratecalculator',
		name: 'aircargoratecalculator',
		component:AirWalletRateCalculator,
		title: 'aircargoratecalculator',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/b2bmarketplace/sellerdetails',
		name: 'b2bmarketplace-sellerdetailslisting',
		component: B2BMarketPlaceSellerDetailsListing,
		title: 'SellerDetailsListing',
		meta: {
			requiresAuth: true
		}
	},
	{
		path: '/b2bmarketplace/deliverydetails',
		name: 'b2bmarketplace-deliverydetailslisting',
		component: B2BMarketPlaceDeliveryDetailsListing,
		title: 'DeliveryDetailsListing',
		meta: {
			requiresAuth: true
		}
	},
];



// WEBPACK FOOTER //
// ./src/modules/cargobooking/router/index.js